module.exports = __webpack_public_path__ + "static/media/email_inactive.ffab9258.svg";